<!--  -->
<template>
  <div class="messageList">
    <div class="messageListTop">
      <img
        src="@/assets/img/msgList/return_icon.png"
        alt=""
        class="return_icon"
        @click="return_btn"
      />
      <div class="msgListTopTitle">消息</div>
      <div
        class="msgListTopCancel"
        @click="msgList.length > 0 ? changeMamagement() : ''"
      >
        {{ btnText }}
      </div>
    </div>
    <div v-if="isTtoast === '1'">
      <div class="messageListMain">
        <van-list
          v-model="loading"
          :immediate-check="false"
          :offset="20"
          :finished="finished"
          @load="onLoad"
        >
          <div class="msgListMainUl">
            <div
              class="msgListMainUl_card"
              v-for="(item, index) in msgList"
              :index="index"
              :key="item.id"
              :id="item.id"
            >
              <div class="selectDiv">
                <img
                  :src="msgIcon"
                  alt=""
                  v-show="isSelect ? false : true"
                  class="msgList_icon"
                  :isDelete="item.isDelete"
                  :id="item.id"
                  @click="selectCard(index, item.id)"
                />
              </div>

              <div
                class="msgListMainLi"
                ref="msgListLi"
                :id="item.id"
              >
                <div class="msgListMainLiTit">
                  <img
                    src="@/assets/img/msgList/ling_icon.png"
                    class="ling_icon"
                    alt=""
                  />
                  <div class="msgListTitle">{{ item.title }}</div>
                </div>
                <div class="msgListMainLiContext">{{ item.content }}</div>
                <div
                  class="msgListMainLiTime"
                  @click="msgList_Url(item.linkUrl, item.linkType, item.businessId)"
                >
                  <span class="msgListTime">{{ item.createTime }}</span>
                  <div
                    class="msgListUrl"
                    v-if="item.linkButtonWord && item.linkType !== 5&&item.linkType !== 6"
                  >
                    <span class="text">{{ item.linkButtonWord }}</span><img
                      src="@/assets/img/msgList/commonIn_icon.png"
                      alt=""
                      class="commonIn_icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>

      <div
        class="msgListBottom"
        v-show="!isSelect"
      >
        <div
          class="msgListAll"
          @click="selectedAllBtn"
        >
          {{ selectedAll ? '取消全选' : '全选' }}
        </div>
        <div
          class="msgListDel"
          @click="deleteBtn"
        >删除</div>
      </div>
    </div>
    <div v-else-if="isTtoast === '2'">
      <div class="msgListNull">
        <img
          src="@/assets/img/msgList/null_msgList.png"
          class="msgListNullIcon"
          alt=""
        />
        <div class="msgListNull_title">暂无消息哦～</div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import { Toast } from 'vant';
import selectedIcon from '@/assets/img/msgList/selected_icon.png';
import changeIcon from '@/assets/img/msgList/change_icon.png';
import { pageList, deleteMsg, deleteBatch } from '@/api/messageList';
import Foot from '@/components/foot/privacy.vue';

export default {
  components: {
    Foot,
  },
  data() {
    return {
      isSelect: true,
      currentIndex: 0,
      msgList: [],
      selectedIcon,
      changeIcon,
      msgIcon: changeIcon,
      selectedAll: false,
      finished: false,
      loading: false,
      pageNum: 1,
      pageSize: 10,
      selectedIdArr: [],
      isTtoast: '3',
      btnText: '',
      pullLoading: false, // 重复刷新
    };
  },
  methods: {
    changeBtnText() {
      if (this.msgList.length > 0) {
        if (this.isSelect) {
          this.btnText = '管理';
        } else {
          this.btnText = '取消';
        }
      } else {
        this.btnText = '';
      }
    },
    onLoad() {
      this.loading = false;
      this.queryPageList();
    },
    return_btn() {
      this.$router.go(-1);
    },

    changeMamagement() {
      const { isSelect } = this;
      this.isSelect = !isSelect;
      this.selectedAll = false;
      this.currentIndex = 0;
      this.selectedIdArr = [];
      this.$refs.msgListLi[this.currentIndex].setAttribute('selected', true);
      document.getElementsByClassName('msgList_icon')[this.currentIndex].setAttribute('src', this.selectedIcon);
      this.selectedIdArr = this.selectedIdArr.concat(
        Number(document.getElementsByClassName('msgListMainLi')[0].getAttribute('id')),
      );
      this.changeBtnText();
    },

    msgList_Url(linkUrl, linkType, businessId) {
      if (linkType === 1) {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: businessId,
          },
        });
      }
      if (linkType === 10) {
        window.location.href = linkUrl;
      }
    },

    selectCard(index, id) {
      const { msgListLi } = this.$refs;
      this.currentIndex = index;
      if (msgListLi[index].getAttribute('selected')) {
        this.$refs.msgListLi[index].removeAttribute('selected');
        document.getElementsByClassName('msgList_icon')[index].setAttribute('src', this.changeIcon);
        this.selectedIdArr = this.selectedIdArr.filter((item) => item !== id);
      } else {
        this.$refs.msgListLi[index].setAttribute('selected', true);
        document.getElementsByClassName('msgList_icon')[index].setAttribute('src', this.selectedIcon);
        this.selectedIdArr = this.selectedIdArr.concat(id);
      }

      if (this.selectedIdArr.length === msgListLi.length) {
        this.selectedAll = true;
      } else {
        this.selectedAll = false;
      }
    },

    selectedAllBtn() {
      this.selectedAll = !this.selectedAll;
      this.selectedIdArr = [];
      if (!this.selectedAll) {
        document.getElementsByClassName('msgListMainLi').forEach((ele, index) => {
          ele.removeAttribute('selected');
          document.getElementsByClassName('msgList_icon')[index].setAttribute('src', this.changeIcon);
        });
        this.selectedIdArr = [];
      } else {
        document.getElementsByClassName('msgListMainLi').forEach((ele, index) => {
          ele.setAttribute('selected', true);
          this.selectedIdArr = this.selectedIdArr.concat(Number(ele.getAttribute('id')));
          document.getElementsByClassName('msgList_icon')[index].setAttribute('src', this.selectedIcon);
        });
      }
    },

    async deleteBtn() {
      // eslint-disable-next-line no-unused-vars
      const imgArr = document.getElementsByClassName('msgList_icon');
      if (this.selectedIdArr.length === 1) {
        const result = await deleteMsg(this.selectedIdArr[0]);
        if (result.code !== 0) {
          Toast(result.msg);
        }
        this.msgList = this.msgList.filter(
          (itemFil) => Number(itemFil.id) !== Number(this.selectedIdArr[0]),
        );
        Toast('删除成功');
      } else {
        const params = this.selectedIdArr;
        const result = await deleteBatch(params);
        if (result.code !== 0) {
          Toast(result.msg);
        }
        this.selectedIdArr.forEach((item) => {
          this.msgList = this.msgList.filter((itemFil) => Number(itemFil.id) !== Number(item));
        });
        Toast('删除成功');
      }

      if (this.msgList.length <= 0) {
        this.isTtoast = '2';
      }

      this.changeBtnText();
    },

    async queryPageList() {
      if (this.pullLoading) return;

      const { msgList } = this;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };

      this.pullLoading = true;
      const result = await pageList(params);
      if (result?.code === 0) {
        Toast.clear();
        const len = result.data && result.data.data && result.data.data.length;

        if (len < this.pageSize) {
          this.finished = true;
        } else {
          this.pageNum += 1;
        }
        this.msgList = msgList.concat(result.data.data);
        this.pullLoading = false;
        if (this.msgList.length > 0) {
          this.isTtoast = '1';
        } else {
          this.isTtoast = '2';
        }

        this.changeBtnText();
      } else {
        Toast(result.msg);
      }
    },
    Toast(msg, time) {
      Toast({
        message: msg,
        duration: time || 3 * 1000,
        position: 'top',
      });
    },
  },
  created() {
    Toast({
      type: 'loading',
      message: '加载中...',
      duration: 0,
    });
    this.queryPageList();
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#f9f9f9');
  },
  beforeDestroy() {
    Toast.clear();
    document.querySelector('body').removeAttribute('style');
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot{
    position: fixed;
}
.messageList {
  position: relative;
  .messageListTop {
    position: fixed;
    top: 0;
    z-index: 666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;
    padding: 0 40px 0 31px;
    color: #000;
    font-size: 36px;
    line-height: 80px;
    background: #f9f9f9;
    .return_icon {
      width: 43px;
      height: 43px;
    }

    .msgListTopCancel {
      color: #333;
      font-size: 25px;
    }
  }
  .messageListMain {
    position: absolute;
    top: 96px;
    width: 678px;
    margin: 0 36px 89px 36px;
    .msgListMainUl {
      .msgListMainUl_card {
        display: flex;
        align-items: center;

        .msgList_icon {
          width: 43px;
          height: 43px;
          margin-right: 14px;
          margin-left: -10px;
        }

        .msgListMainLi {
          width: 100%;
          margin-bottom: 22px;
          background: #fff;
          border-radius: 14px;

          .msgListMainLiTit {
            position: relative;
            padding: 42px 0 27px 22px;

            .ling_icon {
              position: absolute;
              top: 45px;
              left: 36px;
              width: 29px;
              height: 29px;
            }
            .msgListTitle {
              margin-left: 58px;
              color: #333;
              font-weight: 500;
              font-size: 29px;
              line-height: 40px;
            }
          }
          .msgListMainLiContext {
            padding: 0 36px 22px 36px;
            color: #333;
            font-size: 25px;
            line-height: 36px;
          }

          .msgListMainLiTime {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 36px;
            color: #787878;
            .msgListTime {
              display: inline-block;
              padding-left: 36px;
              font-size: 25px;
              line-height: 36px;
            }

            .msgListUrl {
              position: relative;
              display: flex;
              font-size: 25px;
              .text {
                margin-right: 65px;
                line-height: 36px;
              }
              .commonIn_icon {
                position: absolute;
                right: 22px;
                bottom: -3.05px;
                width: 43px;
                height: 43px;
              }
            }
          }
        }
      }
      // width: 678px;
    }
  }

  .msgListBottom {
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 89px;
    padding: 0 36px;
    background: #fefffe;
    box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);

    .msgListAll {
      color: #787878;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }

    .msgListDel {
      width: 236px;
      height: 71px;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 71px;
      text-align: center;
      background: #ff6c02;
      border-radius: 35px;
    }
  }

  .msgListNull {
    text-align: center;

    .msgListNullIcon {
      width: 290px;
      height: 290px;
      margin-top: 370px;
    }

    .msgListNull_title {
      color: #787878;
      font-weight: 600;
      font-size: 29px;
      line-height: 40px;
    }
  }
}
</style>
